export default "__VITE_PUBLIC_ASSET__ccbfafe0__"